/**
 * Middleware for the contacts feature.
 *
 * Listens for WebSocket messages related to contact sync
 * and translates them into Redux actions.
 */
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { queueService } from '../interpreter-queue/InterpreterQueueService';
import { syncContacts } from './actions';
// The queue listener generation of the listener below. A sign-out removes
// every queue listener (queueService.disconnect) while the app stays open, so
// the next sign-in registers it again (Robert, 2026-10-29).
let _listenersFor;
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    if (_listenersFor !== queueService.listenerGeneration()) {
        _listenersFor = queueService.listenerGeneration();
        initializeContactsListeners(store);
    }
    return result;
});
/**
 * Wire up WebSocket events from the InterpreterQueueService
 * to Redux dispatches for contacts sync.
 */
function initializeContactsListeners(store) {
    if (!queueService?.on) {
        return;
    }
    // Another device changed contacts — sync from server
    queueService.on('contactsChanged', () => {
        store.dispatch(syncContacts());
    });
    console.log('[Contacts] Middleware initialized');
}
